import { 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    Box, 
    Grid, 
    Typography, 
    useMediaQuery,
    Container,
    Card,
    Button,
    Fade,
    Chip,
    IconButton
} from "@mui/material";
import React, { useState, useEffect } from "react";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { 
    HelpOutline, 
    GetApp, 
    Email, 
    Phone, 
    WhatsApp,
    Apple,
    Microsoft 
} from '@mui/icons-material';

const FaQqSection = () => {

    const isMobile = useMediaQuery("(max-width:900px)");
    const isTablet = useMediaQuery("(max-width:1200px)");
    const [expanded, setExpanded] = useState("panel1");
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleWindowStore = () => {
        const url = 'https://apps.microsoft.com/detail/9P8QKZ93ZC28?hl=en-us&gl=IN&ocid=pdpshare'
        window.open(url, '_blank', 'noreferrer');
    }

    const handlePlayStore = () => {
        const url = 'https://play.google.com/store/apps/details?id=com.classiolabs.vsmart'
        window.open(url, '_blank', 'noreferrer');
    }

    const faqData = [
        {
            panel: 'panel1',
            question: 'What is V Smart Exam Prep Test Series?',
            answer: 'V Smart Exam Prep offers high-quality test series for CA Foundation, Inter, and Final students to help them assess their preparation before exams.'
        },
        {
            panel: 'panel2',
            question: 'How do I register for the test series?',
            answer: 'You can register online through our official website by selecting the desired test series and completing the payment process.'
        },
        {
            panel: 'panel3',
            question: 'What types of test series are available?',
            answer: (
                <Box>
                    <Typography sx={{ color: '#64748b', fontSize: '0.95rem', mb: 1 }}>
                        We offer:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, color: '#64748b' }}>
                        <li style={{ marginBottom: '8px' }}>Portionwise Tests</li>
                        <li style={{ marginBottom: '8px' }}>Chapter-wise Tests</li>
                        <li style={{ marginBottom: '8px' }}>Full Course Tests</li>
                    </Box>
                </Box>
            )
        },
        {
            panel: 'panel4',
            question: 'Are the test papers designed as per ICAI standards?',
            answer: 'Yes, our test papers are prepared by expert faculty and closely follow ICAI\'s latest exam pattern and difficulty level.'
        },
        {
            panel: 'panel5',
            question: 'How will I receive the test papers?',
            answer: 'Test papers will be available for download on your dashboard after successful registration as per scheduled dates.'
        },
        {
            panel: 'panel6',
            question: 'How do I submit my answers for evaluation?',
            answer: 'You need to write your answers on paper, scan them, and upload them to the portal within the given time frame.'
        },
        {
            panel: 'panel7',
            question: 'Are these Test Series Flexible?',
            answer: 'Yes we do offer customized test series as per students convenience and level of preparation.'
        },
        {
            panel: 'panel8',
            question: 'How long does it take to receive the checked answer sheets?',
            answer: 'Our evaluators will check your answers within 6-8 working days and provide detailed feedback.'
        },
        {
            panel: 'panel9',
            question: 'Will I get model answers and suggested solutions?',
            answer: 'Yes, we provide suggested answers along with the checked papers to help you understand the correct approach.'
        },
        {
            panel: 'panel10',
            question: 'What is the fee structure for the test series?',
            answer: 'Fees vary depending on the type of test series. You can check the latest pricing on our website.'
        },
        {
            panel: 'panel11',
            question: 'What payment methods are available?',
            answer: 'We accept UPI, net banking, credit/debit cards, and other online payment methods.'
        },
        {
            panel: 'panel12',
            question: 'Is there any refund policy?',
            answer: 'No, once a test series is purchased, it is non-refundable.'
        },
        {
            panel: 'panel13',
            question: 'What if I face issues while uploading my answer sheet?',
            answer: 'You can contact our support team via email or WhatsApp for technical assistance.'
        },
        {
            panel: 'panel14',
            question: 'Can I access the test series on mobile?',
            answer: 'Yes, our website is mobile-friendly, and you can download or upload test papers from your phone.'
        },
        {
            panel: 'panel15',
            question: 'Who do I contact for further queries?',
            answer: (
                <Box>
                    <Typography sx={{ color: '#64748b', fontSize: '0.95rem', mb: 1 }}>
                        You can reach out to our support team via:
                    </Typography>
                    <Typography sx={{ color: '#64748b', fontSize: '0.95rem', mb: 0.5 }}>
                        Email: examprep@vsmartacademy.com
                    </Typography>
                    <Typography sx={{ color: '#64748b', fontSize: '0.95rem' }}>
                        WhatsApp: 9130039454/55
                    </Typography>
                </Box>
            )
        }
    ];

    return (
        <Box
            sx={{
                position: 'relative',
                py: { xs: 4, md: 6 },
                px: { xs: 1, md: 2 },
                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.05) 0%, transparent 50%)',
                    pointerEvents: 'none',
                }
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={4}>
                    {/* Left Side - Info Section */}
                    <Grid item xs={12} md={5}>
                        <Fade in={isVisible} timeout={800}>
                            <Box sx={{ pr: { md: 3 } }}>
                                {/* Header */}
                                <Box sx={{ mb: { xs: 2, md: 4 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, md: 2 } }}>
                                        <Box
                                            sx={{
                                                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                                                borderRadius: '50%',
                                                p: { xs: 1, md: 1.5 },
                                                mr: { xs: 1.5, md: 2 },
                                                boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3)',
                                            }}
                                        >
                                            <HelpOutline sx={{ 
                                                fontSize: { xs: '1.2rem', md: '1.8rem' }, 
                                                color: 'white',
                                            }} />
                                        </Box>
                                        <Typography 
                                            variant="h3"
                                            sx={{ 
                                                fontWeight: 700,
                                                color: '#1e293b',
                                                fontSize: { xs: '2.1rem', md: '3.2rem' },
                                                background: 'linear-gradient(135deg, #1e293b 0%, #475569 100%)',
                                                backgroundClip: 'text',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                            }}
                                        >
                                            FAQ
                                        </Typography>
                                    </Box>
                                    
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            color: '#334155',
                                            fontSize: { xs: '1.3rem', md: '1.8rem' },
                                            fontWeight: 600,
                                            mb: { xs: 1, md: 2 },
                                        }}
                                    >
                                        Still have any questions?
                                    </Typography>
                                    
                                    <Typography
                                        sx={{
                                            color: '#64748b',
                                            fontSize: { xs: '1.05rem', md: '1.25rem' },
                                            lineHeight: 1.7,
                                            mb: { xs: 0.5, md: 1 },
                                        }}
                                    >
                                        If you have any doubts or queries, feel free to reach out to us by shooting
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#64748b',
                                            fontSize: { xs: '1.05rem', md: '1.25rem' },
                                            lineHeight: 1.7,
                                        }}
                                    >
                                        us an email at support@globalvsmart.com or by calling us at +91-9876543210.
                                    </Typography>
                                </Box>

                                {/* Contact Information */}
                                <Box sx={{ mb: { xs: 2, md: 4 } }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: '#1e293b',
                                            fontWeight: 600,
                                            mb: { xs: 1.5, md: 3 },
                                            fontSize: { xs: '1.25rem', md: '1.6rem' },
                                        }}
                                    >
                                        Contact Information
                                    </Typography>

                                    <Box sx={{ 
                                        display: 'flex', 
                                        flexDirection: { xs: 'row', md: 'column' }, 
                                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                                        gap: { xs: 1, md: 2 },
                                        justifyContent: { xs: 'space-between', md: 'flex-start' }
                                    }}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            minWidth: { xs: 'auto', md: '100%' }
                                        }}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                                                    borderRadius: '50%',
                                                    p: { xs: 0.5, md: 1 },
                                                    mr: { xs: 1, md: 2 },
                                                    boxShadow: '0 4px 20px rgba(5, 150, 105, 0.3)',
                                                }}
                                            >
                                                <Email sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, color: 'white' }} />
                                            </Box>
                                            <Typography sx={{ 
                                                color: '#334155', 
                                                fontSize: { xs: '1rem', md: '1.2rem' },
                                                display: { xs: 'block', sm: 'block' }
                                            }}>
                                                support@globalvsmart.com
                                            </Typography>
                                        </Box>

                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            minWidth: { xs: 'auto', md: '100%' }
                                        }}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                                                    borderRadius: '50%',
                                                    p: { xs: 0.5, md: 1 },
                                                    mr: { xs: 1, md: 2 },
                                                    boxShadow: '0 4px 20px rgba(220, 38, 38, 0.3)',
                                                }}
                                            >
                                                <Phone sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, color: 'white' }} />
                                            </Box>
                                            <Typography sx={{ 
                                                color: '#334155', 
                                                fontSize: { xs: '1rem', md: '1.2rem' },
                                                display: { xs: 'block', sm: 'block' }
                                            }}>
                                                +91-9876543210
                                            </Typography>
                                        </Box>

                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            minWidth: { xs: 'auto', md: '100%' }
                                        }}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                                                    borderRadius: '50%',
                                                    p: { xs: 0.5, md: 1 },
                                                    mr: { xs: 1, md: 2 },
                                                    boxShadow: '0 4px 20px rgba(5, 150, 105, 0.3)',
                                                }}
                                            >
                                                <WhatsApp sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, color: 'white' }} />
                                            </Box>
                                            <Typography sx={{ 
                                                color: '#334155', 
                                                fontSize: { xs: '1rem', md: '1.2rem' },
                                                display: { xs: 'block', sm: 'block' }
                                            }}>
                                                WhatsApp Support
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Download App Section */}
                                <Box sx={{ mt: { xs: 2, md: 4 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1.5, md: 3 } }}>
                                        <Box
                                            sx={{
                                                background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                                                borderRadius: '50%',
                                                p: { xs: 1, md: 1.5 },
                                                mr: { xs: 1.5, md: 2 },
                                                boxShadow: '0 8px 32px rgba(245, 158, 11, 0.3)',
                                            }}
                                        >
                                            <GetApp sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' }, color: 'white' }} />
                                        </Box>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1e293b',
                                                fontWeight: 600,
                                                fontSize: { xs: '1.25rem', md: '1.6rem' },
                                            }}
                                        >
                                            Download ExamPrep App Now
                                        </Typography>
                                    </Box>

                                    <Box 
                                        sx={{ 
                                            display: 'flex',
                                            flexDirection: 'row',
                                            gap: { xs: 1, sm: 2 },
                                            alignItems: 'flex-start',
                                            justifyContent: { xs: 'space-between', sm: 'flex-start' }
                                        }}
                                    >
                                        <Card
                                            onClick={handlePlayStore}
                                            sx={{
                                                p: { xs: 0.8, sm: 1.5 },
                                                borderRadius: '16px',
                                                background: 'rgba(255, 255, 255, 0.8)',
                                                backdropFilter: 'blur(20px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                flex: { xs: 1, sm: 'none' },
                                                display: 'flex',
                                                justifyContent: 'center',
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                                                }
                                            }}
                                        >
                                            <img 
                                                src="img/playstore.svg" 
                                                alt="Google Play Store" 
                                                style={{ 
                                                    height: window.innerWidth <= 600 ? '30px' : '40px', 
                                                    width: 'auto' 
                                                }} 
                                            />
                                        </Card>

                                        <Card
                                            sx={{
                                                p: { xs: 0.8, sm: 1.5 },
                                                borderRadius: '16px',
                                                background: 'rgba(255, 255, 255, 0.8)',
                                                backdropFilter: 'blur(20px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                flex: { xs: 1, sm: 'none' },
                                                display: 'flex',
                                                justifyContent: 'center',
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                                                }
                                            }}
                                        >
                                            <img 
                                                src="img/applestore.svg" 
                                                alt="Apple App Store" 
                                                style={{ 
                                                    height: window.innerWidth <= 600 ? '30px' : '40px', 
                                                    width: 'auto' 
                                                }} 
                                            />
                                        </Card>

                                        <Card
                                            onClick={handleWindowStore}
                                            sx={{
                                                p: { xs: 0.8, sm: 1.5 },
                                                borderRadius: '16px',
                                                background: 'rgba(255, 255, 255, 0.8)',
                                                backdropFilter: 'blur(20px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                flex: { xs: 1, sm: 'none' },
                                                display: 'flex',
                                                justifyContent: 'center',
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                                                }
                                            }}
                                        >
                                            <img 
                                                src="img/windowstore.svg" 
                                                alt="Windows Store" 
                                                style={{ 
                                                    height: window.innerWidth <= 600 ? '30px' : '40px', 
                                                    width: 'auto' 
                                                }} 
                                            />
                                        </Card>
                                    </Box>
                                </Box>
                            </Box>
                        </Fade>
                    </Grid>
                    
                    {/* Right Side - FAQ Accordions */}
                    <Grid item xs={12} md={7}>
                        <Fade in={isVisible} timeout={1000}>
                            <Box 
                                sx={{ 
                                    pl: { md: 3 },
                                    height: { xs: 'auto', md: '600px' },
                                    overflow: 'auto',
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: 'rgba(0,0,0,0.1)',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                                        borderRadius: '10px',
                                    },
                                }}
                            >
                                {faqData.map((faq, index) => (
                                    <Card
                                        key={faq.panel}
                                        sx={{
                                            mb: 2,
                                            borderRadius: '16px',
                                            background: 'rgba(255, 255, 255, 0.7)',
                                            backdropFilter: 'blur(20px)',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            boxShadow: expanded === faq.panel 
                                                ? '0 12px 40px rgba(59, 130, 246, 0.15)' 
                                                : '0 4px 20px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.3s ease',
                                            overflow: 'hidden',
                                            '&:hover': {
                                                boxShadow: '0 8px 32px rgba(59, 130, 246, 0.1)',
                                            }
                                        }}
                                    >
                                        <Accordion
                                            expanded={expanded === faq.panel}
                                            onChange={handleChange(faq.panel)}
                                            sx={{
                                                background: 'transparent',
                                                boxShadow: 'none',
                                                '&:before': { display: 'none' },
                                                '&.Mui-expanded': { margin: 0 },
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={
                                                    <Box
                                                        sx={{
                                                            background: expanded === faq.panel 
                                                                ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
                                                                : 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                                                            borderRadius: '50%',
                                                            p: 0.5,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            transition: 'all 0.3s ease',
                                                            boxShadow: '0 4px 20px rgba(59, 130, 246, 0.3)',
                                                        }}
                                                    >
                                                        {expanded === faq.panel ? (
                                                            <RemoveIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
                                                        ) : (
                                                            <AddIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
                                                        )}
                                                    </Box>
                                                }
                                                sx={{
                                                    p: 2,
                                                    '& .MuiAccordionSummary-content': {
                                                        alignItems: 'center',
                                                        margin: "0px !important",
                                                    },
                                                    '&.Mui-expanded': {
                                                        minHeight: 'auto',
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                                    <Chip
                                                        label={`${index + 1}`}
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                                                            color: 'white',
                                                            fontWeight: 600,
                                                            mr: 2,
                                                            minWidth: '30px',
                                                            height: '30px',
                                                            '& .MuiChip-label': {
                                                                px: 1
                                                            }
                                                        }}
                                                    />
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: '#1e293b',
                                                            fontSize: { xs: '1.15rem', md: '1.35rem' },
                                                            textAlign: 'left',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                        {faq.question}
                                                    </Typography>
                                                </Box>
                                            </AccordionSummary>
                                            <AccordionDetails
                                                sx={{
                                                    pt: 0,
                                                    pb: 2,
                                                    px: 2,
                                                    background: 'rgba(248, 250, 252, 0.5)',
                                                    borderTop: '1px solid rgba(226, 232, 240, 0.6)',
                                                }}
                                            >
                                                <Box sx={{ pl: 5, mt:2 }}>
                                                    {typeof faq.answer === 'string' ? (
                                                        <Typography
                                                            sx={{
                                                                color: '#64748b',
                                                                fontSize: { xs: '1.05rem', md: '1.2rem' },
                                                                lineHeight: 1.7,
                                                                textAlign: 'left'
                                                            }}
                                                        >
                                                            {faq.answer}
                                                        </Typography>
                                                    ) : (
                                                        faq.answer
                                                    )}
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Card>
                                ))}
                            </Box>
                        </Fade>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default FaQqSection;
